import downloadBinToFile from '../scripts/file_download'
import { Permissions } from '../client_auth/permissions'

AnalyticsCtrl.$inject = ['$scope', 'analyticsApi', 'auth']

export default function AnalyticsCtrl($scope, analyticsApi, auth) {
  $scope.canManageAnalytics = false

  // Check if user has AnalyticsManager permission
  auth.doesUserHavePermission([Permissions.AnalyticsManager]).then(function(hasPermission) {
    $scope.canManageAnalytics = hasPermission
  })

  $scope.getGoalAlignmentContentReport = function() {
    analyticsApi.getGoalAlignmentContentReport().then(function(data) {
      var today = new Date()
      var timestamp = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
      downloadBinToFile(data, timestamp + '-content_report.csv', 'application/csv')
    })
  }
}
